import { FC } from "react";
import NavbarPlaceholder from "./navbar-placeholder";
import NavbarContainer from "./navbar-container";

const Navbar: FC = () => {
  return (
    <>
      <NavbarPlaceholder />
      <NavbarContainer />
    </>
  );
};

export default Navbar;
